import * as React from 'react';
import ConsoleLayout from '../Console/ConsoleLayout';

class AdminLayout extends React.Component<any, any> {
    public render() {
        return (
            <ConsoleLayout>
                {this.props.children}
            </ConsoleLayout>
        );
    }
}

export default AdminLayout;
